/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Br_History_Selector_TriggerInputs */



/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} selected item" |
* | "other" | "{count} selected items" |
* | "zero" | "Boiler/Substation" |
*
* @param {Br_History_Selector_TriggerInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const br_history_selector_trigger = /** @type {((inputs: Br_History_Selector_TriggerInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Selector_TriggerInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		const countPlural = registry.plural("en", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} selected item`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} selected items`);
		if (countPlural === "zero") return /** @type {LocalizedString} */ (`Boiler/Substation`);
		return /** @type {LocalizedString} */ ("br_history_selector_trigger");
	}
	{
		const countPlural = registry.plural("fr", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} élément sélectionné`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} éléments sélectionnés`);
		if (countPlural === "zero") return /** @type {LocalizedString} */ (`Chaufferie/Sous-station`);
		return /** @type {LocalizedString} */ ("br_history_selector_trigger");
	}
});